import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'listFilterPipe',
    pure: false
})
@Injectable()
export class ListFilterPipe implements PipeTransform {
    transform(itemArray: any[], value: Object): any {
        if (!itemArray || !value) {
            return false;
        }
        return itemArray.filter(item => item.indexOf(value) !== -1);
    }
}